import React from 'react';
import Helmet from 'react-helmet';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

const PressRoom = () => {
	return (
		<div className="press-room">
			<Helmet>
				<title>Press Room &#124; SentrySafe</title>
				<meta name="description" content="Our Press Room offers the latest news about SentrySafe products. View press releases." />
			</Helmet>

			<Breadcrumb>
				<BreadcrumbItem label="Learn" />
				<BreadcrumbItem label="Press Room" />
			</Breadcrumb>

			<header className="row header-callout">
				<div className="col">
					<h1>SentrySafe Press Room</h1>
				</div>
			</header>

			<div className="accent-image">
				<img
					src={require('../../resources/img/hero/press-room.jpg')}
					alt="Microphone Next To Laptop"
				/>
			</div>

			<section className="row">
				<div className="col sm-12 releases">
					<h2 className="title">Press Releases</h2>
					<ul>
						<li>July 18, 2017 &#45; <Link to="https://cdn.masterlock.com/masterlock/resources/documents/pdf/PR_ML_QAP-Pistol-Safe_July-2017.pdf" target="_blank">SentrySafe Introduces Expanded&#45;Capacity Gun Safes With Whisper&#45;Quiet Technology &#40;PDF&#41;</Link></li>
					</ul>
				</div>
			</section>
		</div>
	);
};

export default PressRoom;


// WEBPACK FOOTER //
// ./src/pages/learn/PressRoom.js